<template>
    <div class="add-photo flex flex-col">
        <h3
            class="page-title color-text font-bold text-28 text-text pt-8 tracking-tight leading-tight mb-2"
        >
            <span class="text-primary">{{ $t("Profile") }}</span>
            {{ $t("photo") }}
        </h3>
        <p class="text-12 tracking-normal text-text opacity-60">
            {{ $t("Add your account photo") }}
        </p>
        <div
            class="form-items form-with-icons pt-10 flex flex-col flex-grow"
            :class="{
                'form-enabled': hasAvatar,
            }"
        >
            <PhotoUploader @addAvatar="addAvatar" />
            <FormulateButton
                :form-handler="formHandler"
                :has-errors="!hasAvatar"
                :title="$t('Save')"
            />
        </div>
    </div>
</template>

<script>
import Close from "../UI/Close";
import PhotoUploader from "../PhotoUploader/PhotoUploader";
import FormulateButton from "../UI/FormulateButton";
export default {
    name: "AddAvatar",

    components: { PhotoUploader, Close, FormulateButton },

    data: function() {
        return {
            avatar: "",
        };
    },

    computed: {
        hasAvatar: function f() {
            if (!this.avatar && this.$user("has_avatar") === 1) {
                return true;
            } else return !!this.avatar;
        },
    },

    methods: {
        formHandler: function() {
            if (this.avatar) {
                this.$http
                    .post("user/saveavatar", { avatar: this.avatar })
                    .then(res => {
                        if (res && res.status !== undefined && res.status) {
                            this.$setState("userUpdate", res.data.user);
                            this.$setState("loginActiveStep", "cause");
                            this.$setState("loginSteps", { signUp: true });
                            this.$setState("startSign", true);
                        }
                    });
            }
        },
        addAvatar: function(img) {
            this.avatar = img;
        },
    },
};
</script>
